/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';

import {ApiConfig} from '../../config/api-config';
import {AdnApiClientService} from '../../common/controller/adn-api-client.service';

@Injectable({providedIn: 'root'})
export class VersionHistoryApiService {
  constructor(private readonly client: AdnApiClientService, private readonly apiConfig: ApiConfig) {
  }

  get(id: string, type: string, page = 1, pageSize = 30): Observable<any> {
    return this.client.request({
      method: 'GET',
      url: this.apiConfig.getVersionedInternalUri('versionhistory'),
      params: {id, type, pageSize, page}
    });
  }
}
